export const ActionButtonsEnum = {
    DELETE : 'delete',
    EDIT : 'edit',
    DEFAULT : 'default',
    STATUS : 'status',
}